import map from "./Data/paths.json";
import Sound from "react-sound";
import music from "./asset/sounds/music.mp3";
import Video from "./components/Video/Video";
import Copyright from "./components/Copyright/Copyright";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import "./App.css";

function App() {
  const [state, setstate] = useState(0);
  const [show, setShow] = useState(false);
  const [playerSound, setPlayerSound] = useState(Sound.status.PLAYING);
  function showDetails(x) {
    setstate(x);
    setShow(true);
    setPlayerSound(Sound.status.PAUSED);
  }

  function close() {
    setShow(false);
    setPlayerSound(Sound.status.PLAYING);
  }

  // music - models (text and videos) - copyright
  return (
    <div className="container">
      <Copyright>
        {" "}
        بُرمِجَ بـ<span style={{ color: "red" }}>♥</span> من قبل العضو: عُمر عبد
        الوارث الظافري{" "}
      </Copyright>
      <Sound url={music} playStatus={playerSound} volume="10" loop="true" />

      <Video data={state} show={show} close={close} />

      <svg
        viewBox="0 0 3115 2566"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="svg"
      >
        {map.map((x, i) => {
          return (
            <path
              fill="rgba(0,0,0,0)"
              d={x.path}
              id={"path" + i}
              onClick={() => {
                showDetails(i);
              }}
            ></path>
          );
        })}
      </svg>
    </div>
  );
}

export default App;
